<template>
  <v-card>
    <v-card-title>{{ $t('competitor.roles') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.items"
        hide-default-headers
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.name="{item}">
          {{ item.name }}
        </template>
        <template v-slot:item.remove="{item}">
          <v-btn color="primary" v-on:click="removeRole(item.id)">{{ $t("ctrl.remove") }}</v-btn>
        </template>
      </v-data-table>
      <v-form>
        <v-select :items="this.$store.getters['competitions']" :label="$t('ctrl.selectCompetition')" 
          item-text="title" item-value="id" v-model="selectedCompetition" />
        <v-select :items="availableRoles" :label="$t('role.title')" 
          v-model="selectedRole" />
        <v-btn color="success" @click="add">{{ $t("ctrl.add") }}</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCCompetitorRoles',
    computed: {
      headers: function(){
        return [
          { text: this.$t('role.title'), value: 'name', align: 'left' },
          { text: this.$t('competition.title'), value: 'competition.title', align: 'left' },
          { text: '', value: 'remove', align: 'left' },
        ];
      }
    },
    methods: {
      removeRole: function(i){
        fccapi.delete(`competitors/${this.$route.params.id}/roles/${i}`).then((r) => {
          this.reload();
        })
      },
      reload: function(){
        fccapi.get(`competitors/${this.$route.params.id}/roles`).then((r) => {
            this.items = r.data;
        })
      },
      add: function(){
        fccapi.post(`competitors/${this.$route.params.id}/roles`, 
          {roleName: this.selectedRole, competitionId: this.selectedCompetition }).then(r => {
          this.reload();
        })
      }
    },
    data: ()=>({
      items: [],
      selectedCompetition: null,
      selectedRole: null,
      availableRoles: [
        "CompetitionObserver",
        "CompetitionReferee"
      ]
    }),
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    },
    mounted: function(){
      this.reload();
    }
  }
</script>